
import React from 'react';

interface MessageActionsProps {
  timestamp: number;
  isUser: boolean;
  isPlaying: boolean;
  isSynthesizing: boolean;
  isDownloading: boolean;
  copied: boolean;
  onSpeak: () => void;
  onDownload: () => void;
  onCopy: () => void;
}

const MessageActions: React.FC<MessageActionsProps> = ({
  timestamp,
  isUser,
  isPlaying,
  isSynthesizing,
  isDownloading,
  copied,
  onSpeak,
  onDownload,
  onCopy
}) => {
  return (
    <div className={`flex items-center gap-3 mt-1.5 px-2 opacity-0 group-hover/msg:opacity-100 transition-opacity duration-200 ${isUser ? 'flex-row-reverse' : ''}`}>
       <span className="text-[9px] text-slate-400 font-bold">
        {new Date(timestamp).toLocaleTimeString('ar-SA', { hour: '2-digit', minute: '2-digit' })}
      </span>
      {!isUser && (
        <div className="flex items-center gap-3">
          <button 
            onClick={onSpeak} 
            disabled={isSynthesizing || isPlaying}
            className={`flex items-center gap-1.5 transition-all ${isPlaying ? 'text-emerald-500' : 'text-slate-400 hover:text-emerald-500'}`}
          >
            <i className={`fas ${isSynthesizing ? 'fa-spinner fa-spin' : (isPlaying ? 'fa-pause-circle' : 'fa-volume-up')} text-[11px]`}></i>
            <span className="text-[9px] font-black uppercase tracking-tighter">{isPlaying ? 'جاري التشغيل' : (isSynthesizing ? 'جاري التوليد' : 'استماع')}</span>
          </button>
          
          <button onClick={onDownload} disabled={isDownloading} className={`text-slate-400 hover:text-emerald-500 transition-all ${isDownloading ? 'text-emerald-500' : ''}`}>
            <i className={`fas ${isDownloading ? 'fa-spinner fa-spin' : 'fa-download'} text-[11px]`}></i>
          </button>

          <button onClick={onCopy} className="text-slate-400 hover:text-emerald-500 transition-all">
            <i className={`fas ${copied ? 'fa-check text-emerald-500' : 'fa-copy'} text-[11px]`}></i>
          </button>
        </div>
      )}
    </div>
  );
};

export default MessageActions;
